import axios, { AxiosRequestConfig } from "axios";
import moment from "moment";

const config: AxiosRequestConfig = {
  baseURL: process.env.REACT_APP_BASE_API,
  timeout: 50000,
  headers: {
    "Content-Type": "application/json",
    Accept: "*",
    "Access-Control-Allow-Origin": "*",
    "Access-Control-Allow-Headers": "*",
  }
};

function getLocalTime() {
  return moment()?.format("YYYY-MM-DDTHH:mm:ss.SSS");
}

const post = async (endpoint: any, body: any) => {
  try {
    config.headers["LocalTime"] = getLocalTime();
    config.headers["lang"] = localStorage.getItem("lang") || "vi";
    const res = await axios.post(endpoint, body, config);
    return res.data;
  } catch (error) {
    return Promise.reject(error);
  }
};

const upload = async (endpoint: any, body: any) => {
  try {
    const formData = new FormData();
    formData.append("file", body.data.file);
    formData.append("folder", body.data.folder || "Common");
    formData.append("fileNameSake", body.data.nameSake);
    delete config.headers['Content-Type'];
    const res = await axios.postForm(endpoint, formData, config);
    return res.data;
  } catch (error) {
    return Promise.reject(error);
  }
};


export const noAuthApiService = {
  post,
  upload,
};


export const authApiService = {
  post,
  upload,
};
